/**
 * PublicCareService
 * Anonymous (public) care catalog endpoints
 */
import { BaseService } from '../base/BaseService';
/**
 * Service for the public care catalog (no authentication required)
 */
export class PublicCareService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PublicCareService.DEFAULT_SERVICE_PATH,
            basePath: PublicCareService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get the public care needs — a flat lookup list (NOT grouped by area).
     * @returns Flat list of public care needs
     */
    async needs() {
        const response = await this.needsRaw();
        return response.data ?? [];
    }
    /**
     * Get the public care needs (flat list) with full response.
     * @returns ResponseData with the flat list of public care needs
     */
    needsRaw() {
        const url = this.buildUrl('needs');
        return this.http.get(url);
    }
    /**
     * Get the extra custom-field definitions the selected need declares, so the public intake form can
     * render and validate them (definitions only). Values are submitted back via the care-request
     * submission as `customFields` keyed by fieldKey.
     * GET api/public/care/needs/{needId}/fields
     * @param needId - The selected care need
     * @returns The need's public custom-field definitions
     */
    async needFields(needId) {
        const response = await this.needFieldsRaw(needId);
        return response.data ?? [];
    }
    needFieldsRaw(needId) {
        const url = this.buildUrl(`needs/${needId}/fields`);
        return this.http.get(url);
    }
}
PublicCareService.DEFAULT_SERVICE_PATH = 'ac-counselling';
PublicCareService.BASE_PATH = 'api/public/care';
//# sourceMappingURL=PublicCareService.js.map